import { render } from "./OrderComplete.vue?vue&type=template&id=7560e3f3"
import script from "./OrderComplete.vue?vue&type=script&lang=js"
export * from "./OrderComplete.vue?vue&type=script&lang=js"

import "./OrderComplete.vue?vue&type=style&index=0&id=7560e3f3&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__